"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchApi = void 0;
const runtime = require("../runtime");
/**
 *
 */
class SearchApi extends runtime.BaseAPI {
    /**
     * Search blocks, transactions, contracts, or accounts by hash/ID
     * Search
     */
    async searchByIdRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling searchById.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/search/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Search blocks, transactions, contracts, or accounts by hash/ID
     * Search
     */
    async searchById(requestParameters, initOverrides) {
        const response = await this.searchByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.SearchApi = SearchApi;
//# sourceMappingURL=SearchApi.js.map